import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HomeComponent } from './components/home.component';
import { HomeRoutes } from './home.routes';
import { ChatComponent } from './components/chat/chat/chat.component';
import { BlocksModule } from '../../blocks/blocks.module';
import { SharedModule } from '../../shared';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
    imports: [
        CommonModule,
        BlocksModule,
        SharedModule,
        HomeRoutes,
        CKEditorModule
    ],
    declarations: [
        HomeComponent,
        ChatComponent
    ],
    exports: [
        HomeComponent,
        ChatComponent
    ]
})

export class HomeModule { }
